import { render, staticRenderFns } from "./V2Badge.vue?vue&type=template&id=08d05ba2&scoped=true&"
import script from "./V2Badge.vue?vue&type=script&lang=js&"
export * from "./V2Badge.vue?vue&type=script&lang=js&"
import style0 from "./V2Badge.vue?vue&type=style&index=0&id=08d05ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d05ba2",
  null
  
)

export default component.exports